import {
    Page,
    Badge,
    ResourceItem,
    ResourceList,
    EmptyState,
    Card,
    TextStyle,
    Filters,
    SkeletonBodyText
} from '@shopify/polaris';
import { apiFetch as fetch } from '../../common/Helpers';
import moment from 'moment';
import React, { Component } from 'react'
import { Helmet } from 'react-helmet';

class ValidationsIndexPage extends Component {

    constructor(props) {
        super(props)

        this.state = {
            status: {
                isRunning: false,
                canRun: false,
                hoursAgo: "",
                validations: [],
            },
            storeInfo: {},
            isLoading: true,
            sortValue: 'DATE_CREATED_DESC',
            queryValue: null,
        };
    }

    componentDidMount() {
        fetch(`api/validations/status`, {
            method: 'GET'
        })
            .then(response => response.json())
            .then(data => this.setState({
                status: {
                    validations: data.validations,
                    isRunning: data.isRunning,
                    canRun: data.canRun,
                    hoursAgo: data.hoursAgo
                },
                isLoading: false
            }));

        this.getStoreInfo();
    }

    render() {
        if (this.state.isLoading)
            return <SkeletonBodyText lines="20" />;

        const emptyStateMarkup =
            <EmptyState
                heading="Create a validation to get started"
                action={{
                    content: 'Create Validation', onAction: () => { this.handleCreateValidation(); }
                }
                }
                image="https://cdn.shopify.com/s/files/1/2376/3301/products/emptystate-files.png"
            >
                <p>
                    You can use validations to find products that are missing tags and have incorrect combination of tags.
        </p>
            </EmptyState >

        let validations = this.state.status.validations
            .filter(item => this.state.queryValue == null || item.name.toUpperCase().includes(this.state.queryValue.toUpperCase()))
            .map((item, index) => {
                return {
                    id: item.id,
                    url: null,
                    name: item.name,
                    invalidProductsCount: item.invalidProductsCount,
                    lastRun: this.parseDate(item.lastRun),
                    created: new Date(item.dateCreated),
                }
            }).sort((a, b) => {
                switch (this.state.sortValue) {
                    case 'NAME_ASC':
                        return a.name.localeCompare(b.name);
                    case 'NAME_DESC':
                        return b.name.localeCompare(a.name);
                    case 'DATE_CREATED_ASC':
                        return a.created - b.created;
                    case 'DATE_CREATED_DESC':
                    default:
                        return b.created - a.created;
                }
            });

        var secondaryAction = {
            content: 'Run All Validations',
            disabled: false,
            onAction: () => {
                this.handleRunValidations();
            }
        }

        if (this.state.status.isRunning || !this.state.status.canRun) {
            secondaryAction.content = "Run All Validations (running...)";
            secondaryAction.disabled = true;
        }

        const filterControl = (
            <Filters
                queryValue={this.state.queryValue}
                queryPlaceholder="Filter validations by name"
                filters={[]}
                appliedFilters={[]}
                onQueryChange={(value) => this.setState({ queryValue: value })}
                onQueryClear={() => this.setState({ queryValue: null })}
                onClearAll={() => this.setState({ queryValue: null })}
            />
        );

        return (
            <div>
                <Helmet>
                    <title>Tag Genie - Validations</title>
                </Helmet>
                <Page
                    title="Validations"
                    primaryAction={{ content: 'Create Validation', disabled: this.state.storeInfo.tierName === "Free", onAction: () => { this.handleCreateValidation(); } }}
                    secondaryActions={[secondaryAction]}
                >
                    <div>{this.state.status.hoursAgo}</div>
                    <Card >
                        <Card.Section>
                            {filterControl}
                            <ResourceList
                                emptyState={emptyStateMarkup}
                                resourceName={{ singular: 'validation', plural: 'validations' }}
                                items={validations}
                                renderItem={this.renderItem}
                                sortValue={this.state.sortValue}
                                sortOptions={[
                                    { label: 'Name A-Z', value: 'NAME_ASC' },
                                    { label: 'Name Z-A', value: 'NAME_DESC' },
                                    { label: 'Newest', value: 'DATE_CREATED_DESC' },
                                    { label: 'Oldest', value: 'DATE_CREATED_ASC' },
                                ]}
                                onSortChange={(selected) => this.setState({ sortValue: selected })}
                            />
                        </Card.Section>
                    </Card>
                </Page>
            </div>
        );
    }

    renderItem = (item) => {
        const { id, name, lastRun, invalidProductsCount } = item;

        return (
            <ResourceItem id={id} url={null} onClick={(e) => { this.handleViewValidation(e, item); }}>
                <div>
                    <div className="operationItemContent">
                        <div className="operationItemContentColumn">
                            <TextStyle variation="strong">{name}</TextStyle>
                        </div>
                        <div className="operationItemContentRight">
                            {invalidProductsCount === 0 && <div>
                                <Badge status="success">Validation passed</Badge>
                            </div>}
                            {invalidProductsCount > 0 && <div>
                                <Badge status="critical">{invalidProductsCount} failing products</Badge>
                            </div>}
                        </div>
                    </div>
                    <span className="operationDescription">Last run - {lastRun.toString()}</span>
                </div>
            </ResourceItem>
        );

    }

    parseDate(stringDate) {
        var momentDate = moment(stringDate);
        return momentDate.toDate();
    }

    handleCreateValidation() {
        this.props.history.push("/validations/new");
    }

    handleViewValidation = (e, item) => {
        this.props.history.push(`/validations/${item.id}`);
    }

    getStoreInfo() {
        fetch(`api/storeConnections/info`, {
            method: 'GET',
        }).then(response => response.json())
            .then((data) => {
                this.setState({
                    storeInfo: data
                })
            });
    }

    handleRunValidations() {
        fetch(`api/validations/run`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            }
        });

        this.setState({
            status: {
                ...this.state.status,
                isRunning: true
            }
        })
    }
}

export default ValidationsIndexPage